import React from 'react'
import { useSelector } from 'react-redux'
import './Header.scss'

export default function Header() {
    const { profile, loading } = useSelector(state => state.profile)
    return (
        <div className="head-row">
            <div className="font-logo-left">
                <div>
                    <label>ระบบการผลิตและการกระจายเมล็ดพันธุ์ข้าว</label>
                </div>
            </div>
            <div className="">
                <label className="font-logo-left2">S</label><label className="font-logo-left3"> mart</label>&nbsp;&nbsp;<label className="font-logo-left2">S</label><label className="font-logo-left3"> eed</label>&nbsp;&nbsp;<label className="font-logo-left2">S</label><label className="font-logo-left3"> tock</label>&nbsp;&nbsp;<label className="font-logo-left2">S</label><label className="font-logo-left3"> ystem</label>
                <h5 className="sub-head text-end">{loading ? '...' : `${profile?.Fname} ${profile?.Lname}`}</h5>
                <h3 className="head-page text-end">{loading ? '...' : profile?.BranchNo?.BranchNo === '00' ? 'กองเมล็ดพันธุ์ข้าว' :
                    'ศูนย์เมล็ดพันธุ์ข้าว' + profile?.BranchNo?.BranchName}</h3>
            </div>
        </div>
    )
}
